import { render } from "./UserSupport.vue?vue&type=template&id=6b942844&scoped=true"
import script from "./UserSupport.vue?vue&type=script&lang=js"
export * from "./UserSupport.vue?vue&type=script&lang=js"

import "./UserSupport.vue?vue&type=style&index=0&id=6b942844&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b942844"]])

export default __exports__